
/**
 * lang.ts
 */

const BASE_URI = 'https://www.dentik.com/php';
// const BASE_URI = '/php';

// 配置网站支持的语言
const langs: any = {
  'en': 'en',
  'zh-cn': 'zh-CN',
};


/**
 * 获取浏览器的语言设置
 * 如果没找到则返回一个默认值 en
 */
export const getLang = () => {
  const lowerLang = (window.navigator.language || 'en').toLowerCase();

  // default: en
  return 'zh-CN';
};

/**
 * 设置 html 标签的 lang
 */
export const setHtmlLang = (lang: string) => {
  // documentElement 根root HTML
  document.documentElement!.setAttribute('lang', lang);
};

// 产品列表
export const getProductsUrl = (lang: string, num: number = 100) => {
  if (lang === 'en') {
    return `${BASE_URI}/products.php?tid=64&num=${num}&language=en`;
  }
  return `${BASE_URI}/products.php?tid=63&num=${num}`;
};

export const getInfoUrl = (lang: string) => {
  if (lang === 'en') {
    return `${BASE_URI}/singlepage.php?id=45&language=en`;
  }
  return `${BASE_URI}/singlepage.php?id=44`;
};

export const getHonorUrl = (lang: string) => {
  if (lang === 'en') {
    return `${BASE_URI}/pic.php?type=资质荣誉&num=100&language=en`;
  }
  return `${BASE_URI}/pic.php?type=资质荣誉&num=100`;
};

export const getKnowledgeUrl = (lang: string) => {
  if (lang === 'en') {
    return `${BASE_URI}/pic.php?type=知识产权&num=100&language=en`;
  }
  return `${BASE_URI}/pic.php?type=知识产权&num=100`;
};

export const getExhibitionUrl = (lang: string, num: number = 100) => {
  if (lang === 'en') {
    return `${BASE_URI}/news.php?newstype=18&num=${num}&language=en`;
  }
  return `${BASE_URI}/news.php?newstype=15&num=${num}`;
};

export const getTestingUrl = (lang: string, num: number = 100) => {
  if (lang === 'en') {
    return `${BASE_URI}/news.php?newstype=19&num=${num}&language=en`;
  }
  return `${BASE_URI}/news.php?newstype=16&num=${num}`;
};

export const getMaterialUrl = (lang: string, num: number = 100) => {
  if (lang === 'en') {
    return `${BASE_URI}/news.php?newstype=20&num=${num}&language=en`;
  }
  return `${BASE_URI}/news.php?newstype=17&num=${num}`;
};

export const getSinglePageUrl = (lang: string, zh: number = 46, en: number = 47) => {
  if (lang === 'en') {
    return `${BASE_URI}/singlepage.php?id=${en}&language=en`;
  }
  return `${BASE_URI}/singlepage.php?id=${zh}`;
};

export const getNewsdetailUrl = (id: string) => {
  return `${BASE_URI}/new.php?nid=${id}`;
};

export const getProductdetailUrl = (id: string) => {
  return `${BASE_URI}/product.php?pid=${id}`;
};
